import { filters } from "../../components/Filters/Filters";
import { pagination } from "../../components/Pagination/Pagination";
import "./combined-press-release-page.scss";

(function () {
    if (document.querySelectorAll(".js-combined-press-release-page").length > 0) {

        const combinedPressReleasePage = {
            init: function () {
                const urlParams = window.location.search;

                filters.init();
                filters.get(urlParams);
                pagination.init();
                combinedPressReleasePage.addEventListeners();
            },
            addEventListeners: () => {
                const filterSubmit = document.getElementById("filter-submit");

                //Filter submit
                if (filterSubmit) {
                    filterSubmit.addEventListener("click", (e: Event) => {
                        e.preventDefault();

                        const urlParams: string = filters.set().toString();

                        window.location.search = urlParams;
                    })
                }
            },
        };

        combinedPressReleasePage.init();
    }
})();
